import AUDIO_USAGES from '@UI/Pages/Administration/AiEngines/audioUsages';
import { REALTIME_DELIVERY_MODE } from '@UI/Pages/Administration/AiEngines/realtimeDeliveryRules';

/** The minimal shape this constraint reads. */
type ChunkingShape = {
	readonly usages: string[];
	readonly deliveryMode: string | null;
};

/** A real-time audio model is always fed chunks: chunking can only be left unchecked for the other modes. */
function isChunkingRequiredForRealtime<T extends ChunkingShape>(value: boolean, formData: T): boolean {
	const hasAudioUsage = formData.usages.some((usage) => AUDIO_USAGES.includes(usage));

	return value || !hasAudioUsage || formData.deliveryMode !== REALTIME_DELIVERY_MODE;
}

export default isChunkingRequiredForRealtime;
